export enum ActionName {
  Click = 'Click',
  Close = 'Close',
  Add = 'Add',
  Pin = 'Pin',
  UnPin = 'UnPin',
  Check = 'Check',
  Uncheck = 'Uncheck',
  DropDownSelect = 'DropDownSelect',
  Delete = 'Delete',
  None = 'None',
}
